import React, { createContext, useContext, useState, ReactNode } from 'react';

export type Language = 'EN' | 'FR' | 'SP';

interface LanguageContextType {
  currentLanguage: Language;
  setLanguage: (language: Language) => void;
  cycleLanguage: () => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState<Language>('EN');

  const setLanguage = (language: Language) => {
    setCurrentLanguage(language);
  };

  const cycleLanguage = () => {
    const languages: Language[] = ['EN', 'FR', 'SP'];
    const currentIndex = languages.indexOf(currentLanguage);
    const nextIndex = (currentIndex + 1) % languages.length;
    setCurrentLanguage(languages[nextIndex]);
  };

  return (
    <LanguageContext.Provider value={{ currentLanguage, setLanguage, cycleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};